import Layout from '@scripts/routes/Layout'
import gsap from 'gsap'
import App from '@scripts/app'

/**
 * Creates a new *Page*.
 *
 * *Page* is the default *Renderer*.
 *
 * Every other renderer should extend *Page* and implements its useful methods.
 *
 * @class
 * @augments Renderer
 */
export default class Home extends Layout {

  onEnter() {
    super.onEnter()

    this.isLeaving = false
    this.isCliking = false
    this.isDrag = false
  }

  getElems() {
    super.getElems()

    this.grid = this.view.querySelector('.js-grid-gallery')
    this.gridDrag = this.view.querySelector('.js-grid-gallery-drag')
    this.gridBtn = document.body.querySelector('.js-grid-switch-btn')
  }

  onEnterCompleted() {
    super.onEnterCompleted()

    this.gridDrag.$component.oParent = this.grid.$component
    this.grid.$component.oDrag = this.gridDrag.$component
  }

  onFirstEnterCompleted() {
    super.onFirstEnterCompleted()

    this.onEnterCompleted()
  }

  onLeave() {
    super.onLeave()

    this.isLeaving = true
    this.grid.$component.disabled(true)
    this.gridDrag.$component.disabled(true)
    App.cursor.toggleMoving(false)
    App.cursor.toggleDragging(false)
    this.toggleBtnGrid(false)
  }

  events() {
    super.events()

    this.addEvent({
      target: this.gridBtn, name: 'click', callback: this.gridClick
    })

    this.addEvent({
      target: this.gridBtn, name: 'mouseenter', callback: this.gridHover.bind(this, true)
    })

    this.addEvent({
      target: this.gridBtn, name: 'mouseleave', callback: this.gridHover.bind(this, false)
    })
  }

  appear({ from, to, trigger, canvas } = {}) {
    const tl = gsap.timeline({
      delay: 1
    })

    tl.add(this.grid.$component.appear(), 'start')
    tl.add(() => this.toggleBtnGrid(true), 'start+=1.75')

    // tl.timeScale(5)

    return tl
  }

  disappearToGallery() {
    this.gridDrag.$component.disabled(true)
    this.grid.$component.resetMove(true)

    const tl = gsap.timeline()

    tl.add(this.grid.$component.appearPanels(true), 'start')

    if (this.isDrag) {
      tl.add(this.gridDrag.$component.appearItems(false), 'start')
    } else {
      tl.add(this.grid.$component.appearPicture(false), 'start')
    }

    return tl
  }

  gridClick() {
    App.locked(true)
    this.isCliking = true
    this.isDrag = !this.isDrag

    if (this.isDrag) {
      this.grid.$component.disabled(true)
      App.cursor.toggleMoving(false)
    } else {
      this.gridDrag.$component.disabled(true)
      App.cursor.toggleDragging(false)
    }

    this.tlGrid = gsap.timeline({
      onComplete: () => {
        if (this.isDrag) {
          App.cursor.toggleDragging(true)
          this.gridDrag.$component.disabled(false)
        } else {
          this.grid.$component.resetMove(false)
          App.cursor.toggleMoving(true)
          this.grid.$component.disabled(false)
          this.gridDrag.$component.reset()
        }

        this.isCliking = false
        App.locked(false)
      }
    })

    this.tlGrid.add(this.grid.$component.switchMode(this.isDrag), 'start')
    this.tlGrid.addLabel('step1')
    this.tlGrid.add(this.grid.$component.appearPanels(false), 'step1')

    if (this.isDrag) {
      this.tlGrid.add(this.gridDrag.$component.appearItems(true), 'step1')
    } else {
      this.tlGrid.add(this.grid.$component.appearPicture(true), 'step1')
    }
  }

  gridHover(bool) {
    if (this.isCliking || this.isLeaving) return
    if (this.tlGridH) this.tlGridH.kill()
    this.tlGridH = gsap.timeline()

    this.tlGridH.add(this.grid.$component.appearPanels(bool), 'start')

    if (this.isDrag) {
      this.tlGridH.add(this.gridDrag.$component.appearItems(!bool), 'start')
    } else {
      this.grid.$component.resetMove(bool)
      this.tlGridH.add(this.grid.$component.appearPicture(!bool), 'start')
    }
  }

  toggleBtnGrid(bool) {
    this.gridBtn.classList.toggle('show', bool)
  }
}
